const fr = {
  welcome_to_agami: 'Bienvenue sur Agami Route',
  login: 'CONNEXION',
  send_email: 'ENVOYER UN EMAIL',
  login_with_password: 'Connexion avec mot de passe',
  login_with_email: 'Connexion avec email seulement',
  lang: 'Française',
  select_lang: 'Choisissez votre langue',
  day: 'Jour',
  night: 'Nuit',
  confirm: 'Confirmer',
  continue: 'Continuer',
  cancel: 'Annuler',
  refresh: 'Recharger',
  yes_continue: 'Oui, continuer',
  start: 'Démarrer',
  back: 'Retour',
  wait: 'Veuillez patienter...',
  headset: 'Veuillez utiliser le casque fourni pour une meilleure expérience',
  raise_volume: 'Augmentez le volume de votre appareil',
  sound: 'Entendez-vous le son correctement ?',
  wait_location: 'Vérification de la précision de la localisation',
  gps: "L'application tente de récupérer votre position",
  gps_error: 'Un problème est survenu avec le GPS de ce téléphone',
  gps_quality_bad: 'Précision de la localisation mauvaise',
  gps_quality_bad_details: 'Vous pourriez rencontrer des problèmes avec la lecture automatique',
  gps_quality_average: 'Précision de la localisation acceptable',
  gps_quality_good: 'Précision de la localisation excellente',
  cookies: 'Il y a déjà une visite en cours',
  cookies_action: 'Souhaitez-vous continuer ou recommencer ?',
  cookies_delete: "Changer d'expérience",
  cookies_maintain: "Continuer l'expérience",
  unlocking:
    "Si vous avez besoin d'utiliser l'application pendant la visite, déverrouillez-la en utilisant ce code",
  unlock: 'Confirmer le déverrouillage ?',
  unlock_subtitle: "Le déverrouillage de l'écran est réservé aux administrateurs uniquement",
  areyouready: 'Prêt à commencer ?',
  welcome: 'BIENVENUE',
  map: 'Carte',
  code: 'Contenu',
  insert_code: 'Saisir la référence du contenu puis appuyer sur "Lecture"',
  faq: [
    {
      q: 'Problèmes de connexion ?',
      a: 'Si vous rencontrez des problèmes de connexion, essayez de...',
    },
    {
      q: 'Autres questions fréquentes',
      a: 'Si vous rencontrez des problèmes de connexion, essayez de...',
    },
  ],
  mobile_only: 'Cette application a été conçue pour les appareils mobiles uniquement.',
  screen_locked: 'Écran verrouillé',
  swipe_left: 'Faites glisser vers la gauche pour déverrouiller',
  admin_title: 'Contrôles administrateur',
  admin_close: 'Fermer',
  admin_test: 'Test audio',
  admin_reset_soft: "Changer d'expérience",
  admin_reset_hard: "Réinitialiser l'application",
  admin_reset_hard_confirm: "Voulez-vous réinitialiser l'application ?",
  admin_reset_hard_desc:
    "La réinitialisation de l'application effacera toutes les expériences enregistrées et leur contenu. Vous devrez les télécharger à nouveau.",
  admin_logout: 'Déconnexion',
  admin_logout_confirm: 'Se déconnecter maintenant?',
  admin_logout_desc: 'Vous devez scanner le QR ou saisir vos identifiants pour vous reconnecter.',
  search_gps: 'En attente de la couverture GPS',
  select_experience: 'Sélectionner une expérience',
  no_experience: "Il semble que vous n'ayez aucune expérience disponible.",
  pause: 'Pause',
  stop: 'Arrêter',
  stop_all: 'Tout arrêter',
  close: 'Fermer',
  no_description: 'Aucune description',
  stop_video: 'Arrêter la lecture vidéo',
  restart: 'Reprendre',
  beforestart: 'Appuyez sur le bouton "Démarrer" lorsque vous êtes prêt à commencer l\'expérience.',
  ispause: "L'EXPÉRIENCE EST EN PAUSE",
  ispause_restart: 'Cliquez sur le bouton "Lecture" pour la reprendre.',
  play: 'Lecture',
  audio_ready: "agami activé! Appuyez sur le bouton ci-dessous pour l'écouter.",
  offline_experience: 'Expérience hors ligne',
  replay_title: 'Le contenu est disponible pour être rejoué',
  replay_message: 'Il y a du contenu disponible que vous avez déjà écouté. Souhaitez-vous le rejouer ?',
  redeem_exp_title: "Échanger l'expérience",
  redeem_exp_result_title: 'Expérience échangée',
  redeem_exp_button: 'ACTIVER',
  go_to_exp_button: 'COMMENCER',
  check_email_login: 'Consultez votre e-mail pour confirmer la connexion.',
  redeemed_until_days: 'Vous avez accès pour les prochains',
  redeemed_until_date: "Vous avez accès jusqu'au",
  alreadly_redeemed:
    'Il semble que vous ayez déjà utilisé ce code auparavant. Vous devriez déjà avoir cette expérience.',
  redeem_ok: "L'expérience a été créée avec succès pour vous.",

  gps_location_unavailable: 'Services de localisation non disponibles',
  gps_location_unavailable_desc:
    "Les services de localisation sont soit désactivés, soit les autorisations d'accès n'ont pas été accordées. Veuillez suivre les instructions pour vérifier les paramètres corrects.",
  gps_location_open_phone_settings: 'Ouvrir les paramètres du téléphone',
  gps_location_browser_in_use: 'le navigateur que vous utilisez',

  gps_location_android_1: 'Allez dans "Position"',
  gps_location_android_2: 'Vérifiez que "Utiliser la position" est activé',
  gps_location_android_3: 'Ouvrez "Autorisations de position de l\'application"',
  gps_location_android_4: "Faites défiler jusqu'au bas de la section “Non autorisé” et vérifiez si",
  gps_location_android_5: 'est là',
  gps_location_android_6:
    'Si c\'est le cas, cliquez dessus et sélectionnez soit "Demander à chaque fois" soit "Autoriser uniquement pendant l\'utilisation de l\'application"',

  gps_location_ios_1: 'Allez dans "Confidentialité et sécurité" > "Services de localisation"',
  gps_location_ios_2: 'Vérifiez que "Services de localisation" est activé',
  gps_location_ios_2_1_chrome:
    'Vérifiez également que le service est actif pour Chrome dans la liste ci-dessous',
  gps_location_ios_2_1_safari:
    'Vérifiez également que le service est actif pour Safari dans la liste ci-dessous',
  gps_location_ios_3: 'Revenez aux paramètres du téléphone',
  gps_location_ios_4: 'Faites défiler vers le bas et recherchez les paramètres de',
  gps_location_ios_5: 'À l\'intérieur des paramètres, recherchez "Position"',
  gps_location_ios_6: 'Définissez-le soit sur "Demander" soit sur "Autoriser"',

  gps_location_chrome_1: 'Ouvrez Chrome',
  gps_location_chrome_2: 'Accédez à',
  gps_location_chrome_3:
    "Ouvrez les paramètres du site en cliquant sur l'icône des curseurs juste à gauche de l'adresse du site web",
  gps_location_chrome_4: 'Sélectionnez "Autorisations"',
  gps_location_chrome_5: 'Vérifiez que "Position" est autorisé',

  gps_location_safari_1: 'Ouvrez Safari',
  gps_location_safari_2: 'Accédez à',
  gps_location_safari_3:
    'Ouvrez les paramètres du site en cliquant sur l\'icône "Aa" juste à gauche de l\'adresse du site web',
  gps_location_safari_4: 'Sélectionnez "Paramètres du site web"',
  gps_location_safari_5:
    'Sous la section "Autoriser", vérifiez que "Position" est défini sur "Demander" ou "Autoriser"',
  gps_location_safari_6: 'Cliquez sur "Terminé"',

  gps_location_browser_1: 'Ouvrez votre navigateur préféré',
  gps_location_browser_2: 'Accédez à',
  gps_location_browser_3: 'Ouvrez les paramètres du site web',
  gps_location_browser_4:
    'Vérifiez que la permission d\'accès à la position est définie sur "Demander" ou "Autoriser"',

  go_without_gps: 'Procédez sans localisation',
  go_without_gps_warning: 'Vous pourrez jouer un contenu uniquement en entrant manuellement son code',

  read_instructions: 'Lire les instructions',

  go_home: 'Accueil',

  multiple_agami_active: 'Plusieurs agami actifs',

  pwa_install_cta: 'Profitez de la meilleure expérience !',
  pwa_install_description:
    'Installez Agami Route sur votre appareil — rapide, légère et fonctionne comme une appli classique.',
  install: 'Installer',
  aria_pwa_install_dialog: "Fenêtre d'installation d'Agami Route",
  aria_dismiss_pwa_install: "Fermer la notification d'installation",

  unsupported_browser_title: 'Navigateur non pris en charge',
  unsupported_browser_description:
    'Certaines fonctions essentielles de cette application ne fonctionnent pas correctement sur ce navigateur.',
  unsupported_browser_open_with: 'Pour un fonctionnement correct, ouvrez cette adresse avec {browser}',
  copy_address: "Copier l'adresse",
  address_copied: 'Adresse copiée',
  address_copy_error: "Impossible de copier l'adresse",
  understood_continue: "J'ai compris, continuer quand même",
  aria_unsupported_browser_dialog: 'Avertissement : navigateur non pris en charge',

  agami_not_found: 'Aucun agami trouvé avec ce code.',
  multiple_agami_found: 'Plusieurs agami trouvés avec ce code.',

  resume: 'Reprendre',

  qr_scan: 'SCANNER LE QR',
  qr_invalid: 'Code QR invalide',
  qr_frame_instruction: 'Cadrez le code QR dans les bordures blanches',

  text_size: 'TAILLE DU TEXTE',
  standard: 'Standard',
  large: 'Grand',
  xlarge: 'Très grand',

  aria_select_experience: "Sélectionner l'expérience",
  aria_download_experience: "Télécharger l'expérience",
  aria_download_experience_in_progress: "Téléchargement de l'expérience {experience}",
  aria_cancel_download: 'Annuler le téléchargement',
  aria_refresh_experience: "Actualiser l'expérience",
  aria_next_element: 'Élément suivant',
  aria_previous_element: 'Élément précédent',
  aria_open_language: 'Ouvrir la sélection de langue',
  aria_close_language: 'Fermer la sélection de langue',
  aria_open_font_size: 'Ouvrir la sélection de taille de texte',
  aria_close_font_size: 'Fermer la sélection de taille de texte',
  aria_activate_dark_theme: 'Thème actuel : jour. Activez pour passer au thème nuit',
  aria_activate_light_theme: 'Thème actuel : nuit. Activez pour passer au thème jour',
  aria_rewind_10_secs: 'Rembobiner de 10 secondes',
  aria_fast_forward_10_secs: 'Avancer de 10 secondes',
  aria_open_audio_player: 'Ouvrir le lecteur audio',
  aria_close_audio_player: 'Fermer le lecteur audio',
  aria_audio_player_dialog: 'Dialogue audio actif',
  aria_audio_playback_progress: 'Progression de la lecture audio',
  aria_audio_elapsed_time: 'Temps écoulé {elapsed}, sur une durée totale de {total}',
  aria_logign_with_email_only: "Passer en mode d'accès par courrier électronique uniquement",
  aria_login_with_email_password: "Passer en mode d'accès avec l'email et le mot de passe",
  aria_offline_mode: 'Accéder au mode hors ligne',
  aria_send_otp_email: "Envoyer un email pour l'accès",
  aria_show_password: 'Afficher le mot de passe',
  aria_hide_password: 'Masquer le mot de passe',
  aria_open_qr_scanner: 'Ouvrir le scanner QR',
  aria_close_qr_scanner: 'Fermer le scanner QR',
  aria_qr_panel: 'Panneau du scanner QR',
  aria_qr_scanner_preview: 'Aperçu de la caméra du scanner QR',
  aria_manual_playback_code_input: 'Code de lecture manuelle',
  aria_start_manual_content: 'Démarrer le contenu manuel',
  aria_redeem_experience: "Activer l'expérience",
  aria_experience_redeem_code_input: "Code de rédemption de l'expérience",
  aria_loading: 'Chargement',
  aria_go_to_experience: "Aller à l'expérience",
  aria_manual_playback_code_dialog: "Fenêtre d'entrée du code de lecture manuelle",
  aria_replay_content_dialog: 'Fenêtre pour réécouter le contenu',
  aria_open_video_player: 'Ouvrir le lecteur vidéo',
  aria_close_video_player: 'Fermer le lecteur vidéo',
  aria_active_video_dialog: 'Fenêtre de vidéo active',
  aria_collapsed_video_player: 'Lecteur vidéo réduit',
  aria_collapse_video_player: 'Réduire le lecteur vidéo',
  aria_expand_video_player: 'Agrandir le lecteur vidéo',
  aria_open_controls_menu: 'Ouvrir le menu de contrôle',
  aria_close_controls_menu: 'Fermer le menu de contrôle',
  aria_onboarding_step_sentence: "Étape d'intégration numéro {current} sur {total}",

  experience_redeemed_successfully: 'Expérience échangée avec succès',
  something_went_wrong: "Quelque chose s'est mal passé",

  language: 'Langue',

  manual_code_heading: 'Vous avez scanné un agami',
  manual_code_intro: "C'est Agami Route.",
  manual_code_explanation: "Pour l'écouter, ouvrez le code dans l'application Agami Route :",
  manual_code_step_1: "Ouvrez Agami Route et choisissez l'expérience qui contient cet agami",
  manual_code_step_2: 'Appuyez sur "Démarrer"',
  manual_code_step_3: 'Ouvrez la section "Contenu"',
  manual_code_step_4: 'Appuyez sur "SCANNER LE QR" et cadrez à nouveau ce code',
  manual_code_qr_hint:
    'Si vous ne trouvez pas le bouton "SCANNER LE QR", saisissez le code manuellement et appuyez sur "Lecture".',
  manual_code_label: 'Code',
  manual_code_cta_get_app: "Télécharger l'app",
  manual_code_cta_continue: "Continuer dans l'application",
  manual_code_footer: 'Pour en savoir plus, visitez',

  aria_logo: "Logo d'Agami Route",
  aria_heading: 'Explication du scan du code manuel',
  aria_explanation: "Explication sur la façon d'utiliser le code manuel scanné",
  aria_button_get_app: "Télécharger l'application Agami Route",
  aria_button_continue: "Continuer dans l'application Agami Route",

  credits: 'Crédits',
  noCredits: "Il n'y a pas encore de crédits pour cette expérience",

  download_experience_title: "Télécharger l'expérience",
  download_experience_preparing: 'Préparation du téléchargement...',
  download_experience_config: 'Téléchargement de la configuration...',
  download_experience_audio: "Téléchargement de l'audio...",
  download_experience_video: 'Téléchargement de la vidéo...',
  download_experience_credits: 'Téléchargement de crédits...',
  download_experience_maps: 'Téléchargement des cartes...',

  download_experience_error: "Erreur lors du téléchargement de l'expérience",
  download_experience_area_too_wide:
    'La zone de carte de cette expérience est trop vaste pour une utilisation hors ligne',
  download_experience_done: 'Expérience téléchargée et prête pour une utilisation hors ligne !',
  download_experierience_config_error:
    "L'expérience enregistrée présente des problèmes de configuration. Allez en ligne et téléchargez-la à nouveau",
  download_experience_not_allowed: "Le mode hors ligne n'est pas autorisé pour cette expérience",

  get_experience_data_error: "Erreur lors de la récupération des données de l'expérience",
  get_experience_config_error: "Erreur lors de la récupération de la configuration de l'expérience",

  session_expired_title: 'Session expirée',
  session_expired_message:
    'Votre session a expiré et vous avez été déconnecté. Veuillez vous reconnecter pour continuer.',
  session_expired_action: 'Se connecter à nouveau',

  wrong_credentials: 'Identifiants incorrects',
  invalid_email: 'E-mail invalide',
  reset_password_instructions: 'Les instructions ont été envoyées. Vérifiez votre e-mail',
};

export default fr;
